var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-date-picker", {
    attrs: {
      type: _vm.type,
      align: "left",
      "unlink-panels": "",
      "range-separator": "至",
      placeholder: "选择日期",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      size: "mini",
      format: "yyyy-MM-dd",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.PICKER_OPTIONS,
    },
    on: { change: _vm.onChange },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }